/**
 * 二级菜单图片音频视频图片指令
 *
 */
'use strict';
angular.module('initMaterialTypeModule', []).directive('materialType', [
    '$compile',
    '$state',
    'resourceCenterService',
    function($compile, $state, resourceCenterService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './resourceCenter/materialResource/directive/initSecNav/init_material_type.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();
                // eslint-disable-next-line lines-around-comment
                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    queryRights();
                }

                /**
                 * [initStatus description]初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        // 获取权限之后，存放的数据。页面根据这个数据遍历生成
                        lists: ['视频', '音频', '图片', '文字'],
                        list: {
                            video: ['video'],
                            audio: ['audio'],
                            pic: ['pic'],
                            word: ['word'],
                        },
                    };
                    $scope.status = {
                        selected: '', // 被选中的定位
                    };
                }

                /**
                 * [queryRights description]获取二级导航权限(调取服务获取)
                 *
                 * @return  {[type]}  [return description]
                 */
                function queryRights() {}

                /**
                 * [goTo description] 修改控制器的类别值，重新请求数据
                 * @param  {[type]}  [description]
                 * @param  {[type]}      [description]
                 * @return {[type]}            [description]
                 */
                $scope.goTo = function(params) {
                    $scope.status.selected = params;
                    $scope.$parentData.typename = params; //修改控制器的数据
                    $scope.initData(); //调用控制器得刷新方法，重新刷新请求数据
                };
            },
        };
    },
]);
